import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    base_url: "https://sportips.fr/api/v1/galerie/endpoints",
    module: {},
  },
  mutations: {
    initModule(state, m) {
      state.module = m;
    },
    initAdmin(state, a) {
      state.admin = a;
    },
  },
  actions: {
  },
  modules: {
  }
})
